<template>
  <standard-dialog v-model="model" :max-width="800" :title="$t('users')" :loading="loading">
    <v-row justify="center" class="pt-5">
      <text-field type="number" v-model="searchUserId" :label="$t('enter_user_id')" />
    </v-row>
    <p v-if="userByIdError" class="my-3" style="font-weight: bold">
      {{ userByIdError }}
    </p>
    <section v-if="searchUserData">
      <v-row justify="center">
        <v-col cols="5">
          <qrcode-vue
            id="qrkodstampa"
            :value="
              JSON.stringify({
                id: selectedQr,
                secure: selectedQrSecret,
              })
            "
            :size="160"
            level="H"
            render-as="svg"
          />
        </v-col>
        <v-col cols="7">
          <div
            style="color: #000 !important; font-weight: 900; margin-left: -15px"
            class="p-3"
          >
            <div>ID: {{ searchUserData.data.id }}</div>
            <div>
              {{
                toLatin(searchUserData.data.name) +
                " " +
                toLatin(searchUserData.data.lastname)
              }}
            </div>
            <div>{{ searchUserData.data.email }}</div>
            <div>{{ searchUserData.data.phone }}</div>
            <div>{{ $t("firm") }}:</div>
            <div v-for="(company, index) in searchUserData.data.companies" :key="index">
              {{ toLatin(company.name) }}
            </div>
          </div>
        </v-col>
      </v-row>
    </section>
    <template #actions>
      <v-btn text @click="close">
        {{ $t("cancel") }}
      </v-btn>
      <primary-button @click="searchUserById" :loading="loading">{{ $t("search") }}</primary-button>
    </template>
  </standard-dialog>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import userService from "@/services/user";
import hasSnackbar from "@/mixins/hasSnackbar";
import hasModel from "@/mixins/hasModel";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  name: "SearchUserDialog",
  mixins: [hasSnackbar, hasModel],
  components: {
    QrcodeVue,
    StandardDialog,
  },
  data() {
    return {
      loading: false,
      searchUserId: "",
      searchUserData: null,
      userByIdError: "",
      selectedQr: "",
      selectedQrSecret: "",
    };
  },
  methods: {
    close() {
      this.model = false;
      this.resetData();
    },
    resetData() {
      this.searchUserId = "";
      this.searchUserData = null;
      this.userByIdError = "";
      this.selectedQr = "";
      this.selectedQrSecret = "";
    },
    searchUserById() {
      this.searchUserData = null;
      this.userByIdError = "";
      this.loading = true;

      userService
        .searchUserById(this.searchUserId)
        .then(({ data }) => {
          if (data) {
            this.searchUserId = "";
            this.searchUserData = data;
            this.selectedQrSecret = data.data.qrCode;
            this.selectedQr = data.data.id;
            this.showSuccessSnackbar(this.$t("user_found"));
          }
        })
        .catch((error) => {
          this.userByIdError = error.response?.data?.message || "";
          this.showErrorSnackbar(
            error.response?.data?.message || this.$t("user_not_found")
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    value(val) {
      if (!val) {
        this.resetData();
      }
    },
  },
};
</script>
